import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { fn } from '@ember/helper';
import { on } from '@ember/modifier';
import { HeadlessForm } from '@universal-ember/form';

export default class MyFormComponent extends Component {
  users = [
    {
      firstName: 'Jane',
      lastName: 'Doe',
    },
    {
      firstName: 'John',
      lastName: 'Smith',
    },
  ];

  @tracked
  selectedIndex = 0;

  resetForm;

  assignReset = (reset) => {
    this.resetForm = reset;
  };

  get currentUser() {
    return this.users[this.selectedIndex];
  }

  selectUser = (index) => {
    this.selectedIndex = index;
    this.resetForm?.();
  };

  handleSubmit = ({ firstName, lastName }) => {
    alert(`Form submitted with: ${firstName} ${lastName}`);
  };

  <template>
    <div class="flex gap-8">
      <div class="flex-initial">
        Select user:
        <ul>
          {{#each this.users as |user index|}}
            <li><a
                class="cursor-pointer"
                {{on "click" (fn this.selectUser index)}}
              >{{user.firstName}}
                {{user.lastName}}</a></li>
          {{/each}}
        </ul>
      </div>

      <HeadlessForm
        @data={{this.currentUser}}
        @onSubmit={{this.handleSubmit}}
        class="flex-1"
        as |form|
      >
        {{(this.assignReset form.reset)}}

        <form.Field @name="firstName" as |field|>
          <div class="my-2 flex flex-col">
            <field.Label>First name</field.Label>
            <field.Input required class="border rounded px-2" />
            <field.Errors />
          </div>
        </form.Field>

        <form.Field @name="lastName" as |field|>
          <div class="my-2 flex flex-col">
            <field.Label>Last name</field.Label>
            <field.Input required class="border rounded px-2" />
            <field.Errors />
          </div>
        </form.Field>

        <button type="submit">Submit</button>
        <button type="reset">Reset</button>

        <p>Click on the reset button above or
          <a {{on "click" form.reset}}>here</a>
          to reset any dirty state</p>
      </HeadlessForm>
    </div>
  </template>
}